export enum RfidCardPaymentDeviceType {
  None = 'None',
  RFID = 'RFID',
  Barcode = 'Barcode',
  All = 'All',
}
